var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',{attrs:{"mode":"out-in"}},[(_vm.isQrCodeUrl)?_c('qr-code-view'):(null != _vm.user)?_c('router-view'):_c('login-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }